<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值总览
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-addvalue-overview mt-md">
    <el-card shadow="never">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="front-line mb">
            <div class="flex align-items-center">
              总收入
              <el-tooltip content="总收入未扣除结算手续费" placement="top">
                <div class="text-muted ml-xs">
                  <span class="iconfont icon-circle-question"></span>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="bg-light radius5" style="height: 165px">
            <div class="flex-center column" style="height: 162px;">
              <div class="text-primary">
                <span class="font-lg">¥</span>
                <span class="ml-sm font-4x">{{ income.total || '0' }}</span>
              </div>
              <span class=""><el-link :underline="false" @click="toExpense">查看余额</el-link></span>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="front-line mb" style="height: 19px">入账统计</div>
              <div class="block-item bg-light radius5 income">
                <span class="title">本月收入</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_month_sum > 0 }">{{ income.cur_month_sum | currency }}</span>
              </div>
              <div class="mt block-item bg-light radius5 income">
                <span class="title">本季收入</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_season_sum > 0 }">{{ income.cur_season_sum | currency }}</span>
              </div>
              <div class="mt block-item bg-light radius5 income">
                <span class="title">本年收入</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_year_sum > 0 }">{{ income.cur_year_sum | currency }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="block-item bg-light radius5 order" style="margin-top: 34px;">
                <span class="title">本月订单</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_month_count > 0 }">{{ income.cur_month_count }}</span>
                <span class="span text-muted">笔</span>
              </div>
              <div class="mt block-item bg-light radius5 order">
                <span class="title">本季订单</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_sesson_count > 0 }">{{ income.cur_sesson_count }}</span>
                <span class="span text-muted">笔</span>
              </div>
              <div class="mt block-item bg-light radius5 order">
                <span class="title">本年订单</span>
                <span class="font-lg text-muted" :class="{ 'text-success': income.cur_year_count > 0 }">{{ income.cur_year_count }}</span>
                <span class="span text-muted">笔</span>
              </div>
            </el-col>
          </el-row>
          
        </el-col>
        <el-col :span="6">
          <div class="front-line mb" style="height: 19px">服务管理统计</div>
          <div
            class="block-item bg-light radius5 service"
            role="button"
            @click="$router.push('/ei/rms?status=1')">
            <span class="title">正常服务</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-success': rms.normal > 0 }">{{ rms.normal }}</span>
            <span class="span text-muted">台</span>
          </div>
          <div
            class="mt block-item bg-light radius5 service"
            role="button"
            @click="$router.push('/ei/rms?status=2')">
            <span class="title">逾期</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-danger': rms.expired > 0 }">{{ rms.expired }}</span>
            <span class="span text-muted">台</span>
          </div>
          <div
            class="mt block-item bg-light radius5 service"
            role="button"
            @click="$router.push('/ei/rms?expiretime=' + oneMonth + '&status=1')">
            <span class="title">30天内到期</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-warning': rms.expired_in_thirty_days > 0 }">{{ rms.expired_in_thirty_days }}</span>
            <span class="span text-muted">台</span>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="front-line mb flex" style="justify-content: space-between;">
            <span>授权管理统计</span>
          </div>
          <div
            class="block-item bg-light radius5"
            role="button"
            @click="$router.push('/ei/ciot')">
            <span class="title">授权总数</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-blue': ciot.total > 0 }">{{ ciot.total }}</span>
            <span class="span text-muted">个</span>
          </div>
          <div
            class="mt block-item bg-light radius5"
            role="button"
            @click="$router.push('/ei/ciot')">
            <span class="title">已售出</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-success': ciot.bound > 0 }">{{ ciot.bound }}</span>
            <span class="span text-muted">个</span>
          </div>
          <div
            class="mt block-item bg-light radius5"
            role="button"
            @click="$router.push('/ei/ciot')">
            <span class="title">待售</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-warning': ciot.available > 0 }">{{ ciot.available }}</span>
            <span class="span text-muted">个</span>
          </div>
        </el-col> -->
      </el-row>
    </el-card>

    <el-card class="mt-md mb-md" shadow="never">
      <el-row :gutter="20">
        <el-col :span="16">
          <income-bar />
        </el-col>
        <el-col :span="8">
          <income-pie />
          <income-line />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { homeStatApi } from '@/api/ei/eiApi'

const today = new Date(new Date().toLocaleDateString()).getTime()

export default {
  name: 'EiOverview',

  components: {
    IncomePie: () => import('./components/IncomePie'),
    IncomeLine: () => import('./components/IncomeLine'),
    IncomeBar: () => import('./components/IncomeBar')
  },

  data() {
    return {
      spread: false,
      loading: false,
      income: {},
      rms: {}
    }
  },

  computed: {
    oneMonth() {
      return (today + 3600 * 1000 * 24 * 30) / 1000
    },

    threeMonth() {
      return (today + 3600 * 1000 * 24 * 90) / 1000
    }
  },


  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      homeStatApi().then(res => {
        if (!res.errno) {
          this.loading = false
          this.income = Object.assign({}, res.data.income)
          this.rms = Object.assign({}, res.data.rms)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    toExpense() {
      this.$router.push('/expense/overview')
    },

  }
}
</script>

<style lang="scss" scoped>
.block-item {
  padding: 10px 20px;
  .title {
    display: inline-block;
    width: 160px;
    color: #666;
  }
  &.order,&.service,&.income {
    height: 45px;
    display: flex;
    align-items: center;
  }
}
</style>
